<div id="teacher-profile-subjects" class="container margin-top-2" *ngIf="!loading">
  <div class="row p-3">
    <div class="col-9">
      <h1 class ="bold primary"><i class="fas fa-graduation-cap"></i> {{'manage-subjects-title'|translate}}</h1>
      
   </div>
   <div class="col-3 text-right">
    <!-- SEND Button -->
    <button class="btn btn-primary"
    [class.spinner]="sending" (click)="sendform()" [disabled]="!validateform">
    <span><mat-icon>save</mat-icon> {{'save'|translate}}</span>
  </button>
   </div>
   <div class="col-12">
    <p class="pt-3"><i class="fas fa-info-circle"></i> {{'subjects-intro-text'|translate}}</p>
   </div>

   <div class="col-12">
    <p class="pt-3">
      {{'legend-subject-1'|translate}}
    </p>
    <p>
      <span class="pending"></span> {{'pending-subject'|translate}}
    </p>
    <p>
      <span class="validated"></span> {{'validated-subject'|translate}}
    </p>
    <p>
      <span class="notValidated"></span> {{'rejected-subject'|translate}}
    </p>
   </div>

  </div>


  <form [formGroup]="form">
    <div class="row margin-auto p-3">
      <div class="col-md-12 border p-3 rounded-card bg-white">

        <!-- schoolar-subjects -->
        <div formArrayName="subjects" class="row p-3 gx-2">
          <div class="block" style="width: 100%;">
            <h2 class=" pb-3 primary"><i class="fas fa-chalkboard-teacher"></i> <strong> {{'schoolar-subjects'|translate}}</strong>
              <button type="button" class=" btn btn-primary float-right" (click)="addSubject()">
                <div class="flex-center">
                  <span class="margin-right-05">{{'add-subject'|translate}}</span>
                  <mat-icon svgIcon="plus"></mat-icon>
                </div>
              </button>
            </h2>
           
            <p class="pb-3">{{'select-subjects-intro-text'|translate}}</p>
          </div>
          <div class="form-group col-md-4 p-2 teacher-materials-box" 
            *ngFor="let subject of subjectsFormArray.controls; let index = index; let last = last; let first = first">
                
                  <div class="flex-end">
                    <button mat-icon-button (click)="removeSubject(index)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </div>

                  <div [formGroupName]="index">

                    <mat-form-field appearance="legacy" *ngIf="!subject?.value?.name">
                      <mat-label>{{'subject'|translate}}</mat-label>
                      <mat-select class="form-control" formControlName="study_lesson" (selectionChange)="onChangeStudyLesson($event,subject)">
                        <mat-option [value]="subject" *ngFor="let subject of subjects" mult>{{subject.name}}
                        </mat-option>
                      </mat-select>
                      <button mat-icon-button matPrefix *ngIf="subject?.value?.study_lesson" type="button"
                        (click)="subject.patchValue({study_lesson:''});subject.get('study_lesson').markAsUntouched() ;$event.stopPropagation();">
                        <mat-icon svgIcon="close-circle" color=""></mat-icon>
                      </button>
                      <mat-error *ngIf="(subject.controls.study_lesson?.invalid && subject.controls.study_lesson?.touched)">
                        {{'valid-select'|translate}}
                      </mat-error>
                    </mat-form-field>

                    <div class="margin-vertical-05 flex-center"
                      *ngIf="!subject?.value?.name && !subject?.value?.study_lesson?.id">
                      {{'or-write-the-name'|translate}}
                    </div>


                    <!-- name other activity -->
                    <ng-container *ngIf="!subject?.value?.study_lesson?.id">
                      <span class="subjectPending">{{'to-be-validated'|translate}} </span>
                      <mat-form-field appearance="legacy">
                        <mat-label>{{'name'|translate}}</mat-label>
                        <input class="form-control" matInput formControlName="name">
                        <mat-error *ngIf="(subject.controls.name?.invalid && subject.controls.name?.touched)">
                          {{'valid-input'|translate}}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>

                   <!-- Niveles-->
                    <mat-form-field appearance="legacy" class="margin-top-05">

                      <mat-select class="form-control" formControlName="lesson_level_id" multiple>
                        <mat-option [value]="level.id" *ngFor="let level of subjectLevels">
                          <span class="flexBetween" [ngClass]="{
                            'pending': lessonLevelStatus[subject.value.study_lesson.id] !== undefined && lessonLevelStatus[subject.value.study_lesson.id][level.id] == 0, 
                            'validated': lessonLevelStatus[subject.value.study_lesson.id] !== undefined && lessonLevelStatus[subject.value.study_lesson.id][level.id] == 1, 
                            'notValidated': lessonLevelStatus[subject.value.study_lesson.id] !== undefined && lessonLevelStatus[subject.value.study_lesson.id][level.id]  == 2}">
                            {{level.name}}
                          </span>
                        </mat-option>
                      </mat-select>

                      <mat-error
                        *ngIf="(subject.controls.lesson_level_id?.invalid && subject.controls.lesson_level_id?.touched)">
                        {{'valid-select'|translate}}
                      </mat-error>
                    </mat-form-field>

                     <!-- price_hour_single -->
                     <mat-form-field appearance="standard" >
                      <mat-label> € {{'per-hour'|translate}}</mat-label>                      
                      <input class="form-control" matInput type="number" formControlName="price_hour_single" [value]="" min="5">
                       <mat-error *ngIf="(subject.controls.price_hour_single?.invalid && subject.controls.price_hour_single?.touched && subject.controls.price_hour_single?.value<5)">
                        {{'valid-input'|translate}}
                      </mat-error> 
                    </mat-form-field>
                  </div>
                </div>
        </div>
      </div>
    </div>


      <div class="row mt-5 p-3">
        <!-- languages-for-foreigners -->
        <div class="col-md-12 border p-3 rounded-card bg-white">
          <div formArrayName="languages" class="row p-3">
            <div class="block" style="width: 100%;">
              <h2 class="pb-3 primary"><i class="fas fa-globe-europe"></i> <strong> {{'languages-for-foreigners'|translate}}</strong>
                <button type="button" class=" btn btn-primary float-right" (click)="addSubjectLang()">
                  <div class="flex-center">
                    <span class="margin-right-05">{{'add-subject'|translate}}</span>
                    <mat-icon svgIcon="plus"></mat-icon>
                  </div>
                </button>
              </h2>
              <p class="pb-3">{{'select-languages-intro-text'|translate}}</p>
            </div>
            <div class="form-group col-md-4 p-2 teacher-materials-box"
              *ngFor="let subject of subjectsLangFormArray.controls; let index = index; let last = last; let first = first">

              <div class="flex-end">
                <button mat-icon-button (click)="removeSubjectLang(index)">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>

              <div [formGroupName]="index">

                <mat-form-field appearance="legacy" *ngIf="!subject?.value?.name">
                  <mat-label>{{'language'|translate}}</mat-label>
                  <mat-select class="form-control" formControlName="study_lesson" (selectionChange)="onChangeStudyLesson($event,subject)">
                    <mat-option [value]="language" *ngFor="let language of languages">{{language.name}}
                    </mat-option>
                  </mat-select>
                  <button mat-icon-button matPrefix *ngIf="subject?.value?.study_lesson" type="button"
                    (click)="subject.patchValue({study_lesson:''});subject.get('study_lesson').markAsUntouched() ;$event.stopPropagation();">
                    <mat-icon svgIcon="close-circle" color=""></mat-icon>
                  </button>
                  <mat-error *ngIf="(subject.controls.study_lesson?.invalid && subject.controls.study_lesson?.touched)">
                    {{'valid-select'|translate}}
                  </mat-error>
                </mat-form-field>

                <div class="margin-vertical-05 flex-center"
                  *ngIf="!subject?.value?.name && !subject?.value?.study_lesson?.id">
                  {{'or-write-the-name'|translate}}
                </div>

                  <!-- name other activity -->
                  <ng-container *ngIf="!subject?.value?.study_lesson?.id">
                    <span class="subjectPending">{{'to-be-validated'|translate}} </span>
                    <mat-form-field appearance="legacy">
                      <mat-label>{{'name'|translate}}</mat-label>
                      <input class="form-control" matInput formControlName="name">
                      <mat-error *ngIf="(subject.controls.name?.invalid && subject.controls.name?.touched)">
                        {{'valid-input'|translate}}
                      </mat-error>
                    </mat-form-field>
                  </ng-container>


                <mat-form-field appearance="legacy" class="margin-top-05">
                  <mat-label>{{'levels'|translate}}</mat-label>
                  <mat-select class="form-control" formControlName="lesson_level_id" multiple>
                    <mat-option [value]="level.id" *ngFor="let level of languageLevels">
                      <span class="flexBetween" 
                      [ngClass]="{
                      'pending': lessonLevelStatus[subject.value.study_lesson.id] !== undefined && lessonLevelStatus[subject.value.study_lesson.id][level.id] == 0, 
                      'validated': lessonLevelStatus[subject.value.study_lesson.id] !== undefined && lessonLevelStatus[subject.value.study_lesson.id][level.id] == 1,
                      'notValidated': lessonLevelStatus[subject.value.study_lesson.id] !== undefined && lessonLevelStatus[subject.value.study_lesson.id][level.id]  == 2}">
                      {{level.name}}
                    </span>
                    
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="(subject.controls.lesson_level_id?.invalid && subject.controls.lesson_level_id?.touched)">
                    {{'valid-select'|translate}}
                  </mat-error>
                </mat-form-field>

                <!-- price_hour_single -->
                <mat-form-field appearance="standard" >
                  <mat-label> € {{'per-hour'|translate}}</mat-label>                      
                  <input class="form-control" matInput type="number" formControlName="price_hour_single" [value]="" min="5" max="100">
                   <mat-error *ngIf="(subject.controls.price_hour_single?.invalid && subject.controls.price_hour_single?.touched)">
                    {{'valid-input'|translate}}
                  </mat-error> 
                </mat-form-field>
              </div>

                    

              <!-- <div class="flex-center margin-top-1">
                <button type="button" class=" btn btn-primary" (click)="addSubjectLang()">
                  <div class="flex-center">
                    <span class="margin-right-05">{{'add-another-1'|translate}}</span>
                    <mat-icon svgIcon="plus"></mat-icon>
                  </div>
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      


      <div class="row mt-5 p-3">
        <!-- other-activities -->
        <div class="col-md-12 border p-3 rounded-card bg-white">
          <div formArrayName="other_activities" class="row p-3">
            <div class="block" style="width: 100%;">
              <h2 class="pb-3 primary"><i class="far fa-bookmark"></i> <strong>  {{'other-activities'|translate}}</strong>
                <button type="button" class=" btn btn-primary float-right" (click)="addSubjectOtherActivity()">
                  <div class="flex-center">
                    <span class="margin-right-05">{{'add-subject'|translate}}</span>
                    <mat-icon svgIcon="plus"></mat-icon>
                  </div>
                </button>
              </h2>
              <p class="pb-3">{{'select-others-intro-text'|translate}}</p>
            </div>
            <div class="form-group col-md-4 p-2 teacher-materials-box"
              *ngFor="let subject of subjectsOtherActivityFormArray.controls; let index = index; let last = last; let first = first">

              <div class="flex-end">
                <button mat-icon-button (click)="removeSubjectOtherActivity(index)">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>

              <div [formGroupName]="index">


                <mat-form-field appearance="legacy" *ngIf="!subject?.value?.name">
                  <mat-label>{{'subject'|translate}}</mat-label>
                  <mat-select class="form-control" formControlName="study_lesson" (selectionChange)="onChangeStudyLesson($event,subject)">
                    <mat-option [value]="other_activity" *ngFor="let other_activity of other_activities" mult>{{other_activity.name}}
                    </mat-option>
                  </mat-select>
                  <button mat-icon-button matPrefix *ngIf="subject?.value?.study_lesson" type="button"
                    (click)="subject.patchValue({study_lesson:''});subject.get('study_lesson').markAsUntouched() ;$event.stopPropagation();">
                    <mat-icon svgIcon="close-circle" color=""></mat-icon>
                  </button>
                  <mat-error *ngIf="(subject.controls.study_lesson?.invalid && subject.controls.study_lesson?.touched)">
                    {{'valid-select'|translate}}
                  </mat-error>
                </mat-form-field>

                <div class="margin-vertical-05 flex-center"
                *ngIf="!subject?.value?.name && !subject?.value?.study_lesson?.id">
                {{'or-write-the-name'|translate}}
              </div>

                  <!-- name other activity -->
                  <ng-container *ngIf="!subject?.value?.study_lesson?.id">
                    <span class="subjectPending">{{'to-be-validated'|translate}} </span>
                    <mat-form-field appearance="legacy">
                      <mat-label>{{'name'|translate}}</mat-label>
                      <input class="form-control" matInput formControlName="name">
                      <mat-error *ngIf="(subject.controls.name?.invalid && subject.controls.name?.touched)">
                        {{'valid-input'|translate}}
                      </mat-error>
                    </mat-form-field>
                  </ng-container>

                  <!-- price_hour_single -->
                  <mat-form-field appearance="standard" >
                    <mat-label> € {{'per-hour'|translate}}</mat-label>
                    <input class="form-control" matInput formControlName="price_hour_single" min="5" max="100">
                    <mat-error *ngIf="(subject.controls.price_hour_single?.invalid && subject.controls.price_hour_single?.touched)">
                      {{'valid-input'|translate}}
                    </mat-error>
                  </mat-form-field>

              </div>

              <!-- <div class="flex-center margin-top-1">
                <button type="button" class=" btn btn-primary" (click)="addSubjectOtherActivity()">
                  <div class="flex-center">
                    <span class="margin-right-05">{{'add-another-activity'|translate}}</span>
                    <mat-icon svgIcon="plus"></mat-icon>
                  </div>
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
     

      <div class="row justify-content-center pb-5">
        <!-- SEND Button -->
        <button mat-raised-button color="primary" class=""
          [class.spinner]="sending" (click)="sendform()" [disabled]="!validateform">
          <span><mat-icon>save</mat-icon> {{'save'|translate}}</span>
        </button>
      </div>
   

  </form>
</div>
